function parseStyle(style: string): {value: number; unit: string} {
    const value = parseInt(style, 10)
    const unit = style.replace(value.toString(), '')

    return {value: value, unit: unit}
}

function getElementMarginBottom(element: HTMLElement): number {
    const elementStyle = window.getComputedStyle(element).marginBottom
    if (elementStyle) {
        const {value, unit} = parseStyle(elementStyle)

        if (unit !== 'px') {
            throw Error('Unsupported unit of margin style')
        }

        return value
    }

    throw Error('Style is not present on element')
}

function getHeighOfNavActionBar(): number {
    const navActionBarElement = document.getElementById('navigation-action-bar')
    if (navActionBarElement) {
        return navActionBarElement.offsetHeight + 2 * getElementMarginBottom(navActionBarElement)
    }

    return 16 // leave space for layout padding
}

export {getHeighOfNavActionBar}
